import { useEffect } from 'react';

interface SEOHeadProps {
  title: string;
  description: string;
  keywords?: string;
  canonical?: string;
  ogImage?: string;
  ogType?: string;
  schema?: object;
}

function setMeta(property: string, content: string, attr: 'name' | 'property' = 'name') {
  let el = document.querySelector(`meta[${attr}="${property}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, property);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setLink(rel: string, href: string) {
  let el = document.querySelector(`link[rel="${rel}"]`) as HTMLLinkElement | null;
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

export default function SEOHead({
  title,
  description,
  keywords = 'gestão de riscos, contratação de seguros, seguros Vitória da Conquista, corretora de seguros',
  canonical,
  ogImage = 'https://www.ibxbrasil.com/og-image.jpg',
  ogType = 'website',
  schema,
}: SEOHeadProps) {
  const fullTitle = title.includes('IBX Brasil') ? title : `${title} | IBX Brasil`;
  const fullCanonical = canonical || `https://www.ibxbrasil.com${window.location.pathname}`;

  useEffect(() => {
    // Título
    document.title = fullTitle;

    // Meta básicas
    setMeta('description', description);
    setMeta('keywords', keywords);

    // Canonical
    setLink('canonical', fullCanonical);

    // Open Graph
    setMeta('og:title', fullTitle, 'property');
    setMeta('og:description', description, 'property');
    setMeta('og:type', ogType, 'property');
    setMeta('og:url', fullCanonical, 'property');
    setMeta('og:image', ogImage, 'property');
    setMeta('og:locale', 'pt_BR', 'property');
    setMeta('og:site_name', 'IBX Brasil', 'property');

    // Twitter Card
    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', fullTitle);
    setMeta('twitter:description', description);
    setMeta('twitter:image', ogImage);

    // Schema.org
    if (schema) {
      const existingScript = document.querySelector('script[data-seo-schema]');
      if (existingScript) existingScript.remove();
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-seo-schema', 'true');
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
    }
  }, [fullTitle, description, keywords, fullCanonical, ogImage, ogType, schema]);

  return null;
}
